import { createContext } from 'react';
import { IItemForGetShortInfoWithStatus, TPropertiesOfPatchChangesForDish } from 'types';

export type TTypeOfModalWindow = Nullable<'toConfirmFieldsClearing' | 'error'>;

export interface ISaveAsPatchState {
	initialFormData: {
		dishId: string;
		customerName: string;
		fetchedRestaurants: IItemForGetShortInfoWithStatus[];
		IDSelectedRestaurantOnRestPropsPage: Nullable<string>;
		price: Nullable<number>;
		isCreatedOnPos: boolean;
		hasPortions: boolean;
		hasOpenPrice: boolean;
		openPrice: Nullable<number>;
		openPriceMaxThreshold: Nullable<number>;
		taxPercent: Nullable<number>;
		hasSchedulePriority: boolean;
		inStop: boolean;
		isCommentVisible: boolean;
		isFiscalized: boolean;
		isTaxPercentProtectedFromSync: boolean;
		activationSchedule: string;
		deactivationSchedule: string;
	};
	typeOfChanges: 'basedChanges' | 'independentChanges';
	IDsSelectedRestaurant: string[];
	selectedProperties: TPropertiesOfPatchChangesForDish[];
	price: Nullable<number>;
	hasOpenPrice: boolean;
	openPrice: Nullable<number>;
	openPriceMaxThreshold: Nullable<number>;
	taxPercent: Nullable<number>;
	inStop: boolean;
	isCommentVisible: boolean;
	isFiscalized: boolean;
	isTaxPercentProtectedFromSync: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const saveAsPatchInitialState: ISaveAsPatchState = {
	initialFormData: {
		dishId: '',
		customerName: '',
		fetchedRestaurants: [],
		IDSelectedRestaurantOnRestPropsPage: null,
		price: null,
		isCreatedOnPos: false,
		hasPortions: false,
		hasOpenPrice: false,
		openPrice: null,
		openPriceMaxThreshold: null,
		taxPercent: null,
		hasSchedulePriority: false,
		inStop: false,
		isCommentVisible: false,
		isFiscalized: false,
		isTaxPercentProtectedFromSync: false,
		activationSchedule: '',
		deactivationSchedule: '',
	},
	typeOfChanges: 'basedChanges',
	IDsSelectedRestaurant: [],
	selectedProperties: [],
	price: null,
	hasOpenPrice: false,
	openPrice: null,
	openPriceMaxThreshold: null,
	taxPercent: null,
	inStop: false,
	isCommentVisible: false,
	isFiscalized: false,
	isTaxPercentProtectedFromSync: false,
	activationSchedule: '',
	deactivationSchedule: '',
	typeOfModalWindow: null,
};

export interface ISaveAsPatchContext extends ISaveAsPatchState {
	saveData(value: 'saveAndMakeOtherChanges' | 'saveAndClose'): void;
	setTypeOfChanges(value: ISaveAsPatchState['typeOfChanges']): void;
	setIDsRestaurant(value: ISaveAsPatchState['IDsSelectedRestaurant']): void;
	setProperties: (value: ISaveAsPatchState['selectedProperties']) => void;
	changePrice(value: ISaveAsPatchState['price']): void;
	toggleHasOpenPrice(): void;
	changeOpenPrice(value: ISaveAsPatchState['openPrice']): void;
	changeOpenPriceMaxThreshold(value: ISaveAsPatchState['openPriceMaxThreshold']): void;
	changeTaxPercent(value: ISaveAsPatchState['taxPercent']): void;
	toggleInStop(): void;
	toggleIsCommentVisible(): void;
	toggleIsFiscalized(): void;
	toggleIsTaxPercentProtectedFromSync(): void;
	changeActivationSchedule(value: ISaveAsPatchState['activationSchedule']): void;
	changeDeactivationSchedule(value: ISaveAsPatchState['deactivationSchedule']): void;
	changeTypeOfModalWindow(value: ISaveAsPatchState['typeOfModalWindow']): void;
}

export const SaveAsPatchContext = createContext<ISaveAsPatchContext>({
	saveData: () => undefined,
	setTypeOfChanges: () => undefined,
	setIDsRestaurant: () => undefined,
	setProperties: () => undefined,
	changePrice: () => undefined,
	toggleHasOpenPrice: () => undefined,
	changeOpenPrice: () => undefined,
	changeOpenPriceMaxThreshold: () => undefined,
	changeTaxPercent: () => undefined,
	toggleInStop: () => undefined,
	toggleIsCommentVisible: () => undefined,
	toggleIsFiscalized: () => undefined,
	toggleIsTaxPercentProtectedFromSync: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...saveAsPatchInitialState,
});
